/** API route map: URLS.Controller.ClientPayrollPayGroup */
export const ClientPayrollPayGroup = {
      Name: 'ClientPayrollPayGroup/',
      GetPayrollPayGroup: 'get',
      AddPayrollPayGroup: 'add',
      Delete: 'delete',
      SearchPayGroupByName: 'search-pay-group-by-name',
      GetEmployees: 'get-employees',
      GetOtherPayGroupEmployees: 'get-other-pay-group-employees',
      CheckExistingRecord: 'check-existing-record',
      UpdatePayrollPayGroup: 'update',
      UpdateThisPayGroup: 'update-this-pay-group',
      UpdateThisPayGroupBulk: 'update-this-pay-group-bulk',
      PayGroupById: 'pay-group-by-id',
      GetPayrolllPaygroup: 'get-payrolll-paygroup',
      GetAllEmployees: 'get-all-employees',
      GetListPayrollSchedulSetup: 'get-list-payroll-schedule-setup',
      GetListPayrollProcessingSchedule: 'get-list-payroll-processing-schedule',
};
